<div class="clock-properties-panel">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div class="settings-section">
      <!-- Clock Properties Section -->
      <div class="properties-section">
        <div class="section-header">
          <mat-icon class="section-icon">schedule</mat-icon>
          <span class="section-title">clock properties</span>
        </div>

        <div class="section-content">
          <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
          </dynamic-form>
        </div>
      </div>

      <!-- Time Format Guide Section -->
      <div class="properties-section">
        <div class="section-header">
          <mat-icon class="section-icon">info</mat-icon>
          <span class="section-title">format guide</span>
        </div>

        <div class="section-content">
          <pre class="format-guide">Y Year YY YYYY
M Month in year M MM MMM
D Day in month D DD
E Days in week E EE EEE EEEE
A AM/PM
J Hour in Day 0-23
H Hour in Dat 1-24
K Hour in am/pm 0-11
L Hour in dat 1-12
N Minutes in hour N NN
S Second in minutes SS</pre>
        </div>
      </div>

      <!-- Font Selector Section -->
      <div class="properties-section">
        <div class="section-header">
          <mat-icon class="section-icon">font_download</mat-icon>
          <span class="section-title">font settings</span>
        </div>

        <div class="section-content">
          <app-font-selector (onChange)="onFontChanged($event, '', 'Clock')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
        </div>
      </div>
    </div>
  }
</div>
